import { random, round2, round2Str } from "../helpers/helpers";
import { thMeterSensorRegistry } from "./thMeterSensorRegistry";

// -------------------------
// helpers
// -------------------------
const formatDate = (date) =>
    `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth() + 1
    ).padStart(2, "0")}-${date.getFullYear()}`;

const formatTime = (h, m) =>
    `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;

export const generateThGetLatestDataDemo = ({
                                                meter_id,
                                                sensor_name, // ⚠️ sensor_name = sensor_id (number)
                                            }) => {
    const now = new Date();

    // -------------------------
    // Resolve meter & sensor from registry
    // -------------------------
    const meterEntry = thMeterSensorRegistry.find(
        (m) => m.meter_id === Number(meter_id)
    );

    console.log(`meterEntrymeterEntrymeterEntry 4${meterEntry}`)
    console.log(meterEntry)

    const sensorEntry = meterEntry?.sensors.find(
        (s) => s.sensor_id === Number(sensor_name)
    );

    const location = meterEntry?.location || "Temperature Monitoring Area";
    const sensorDisplayName =
        sensorEntry?.sensor_name || `Sensor ${sensor_name}`;

    const [minTemp, maxTemp] = sensorEntry?.temp_range || [20, 25];
    const [minHumi, maxHumi] = sensorEntry?.humi_range || [45, 60];

    // -------------------------
    // Live values (within range)
    // -------------------------
    const temperature = random(minTemp, maxTemp);
    const humidity = random(minHumi, maxHumi);

    // -------------------------
    // Daily stats
    // -------------------------
    const dailyMinTemp = random(minTemp - 2, minTemp + 1);
    const dailyMaxTemp = random(maxTemp - 1, maxTemp + 2);
    const dailyAvgTemp = round2((dailyMinTemp + dailyMaxTemp) / 2);

    const dailyMinHum = random(minHumi - 5, minHumi);
    const dailyMaxHum = random(maxHumi, maxHumi + 8);
    const dailyAvgHum = round2((dailyMinHum + dailyMaxHum) / 2);

    const dailyMinTempTime = formatTime(6, random(0, 59));
    const dailyMaxTempTime = formatTime(14, random(0, 59));
    const dailyMinHumTime = formatTime(15, random(0, 59));
    const dailyMaxHumTime = formatTime(9, random(0, 59));

    // -------------------------
    // Monthly stats (past days only)
    // -------------------------
    const daysCompleted = now.getDate();

    const randomPastDate = () => {
        const d = new Date(now);
        d.setDate(random(1, daysCompleted));
        return formatDate(d);
    };

    const monthlyMinTemp = random(minTemp - 3, minTemp);
    const monthlyMaxTemp = random(maxTemp, maxTemp + 3);
    const monthlyAvgTemp = round2(
        (monthlyMinTemp + monthlyMaxTemp) / 2
    );

    const monthlyMinHum = random(minHumi - 8, minHumi);
    const monthlyMaxHum = random(maxHumi, maxHumi + 10);
    const monthlyAvgHum = round2(
        (monthlyMinHum + monthlyMaxHum) / 2
    );

    // -------------------------
    // last_seen
    // -------------------------
    const lastSeen = `${String(now.getDate()).padStart(2, "0")}-${now.toLocaleString(
        "default",
        { month: "short" }
    )}-${now.getFullYear().toString().slice(-2)} ${String(
        now.getHours()
    ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;

    return {
        // Identity
        location,
        sensor_name: sensorDisplayName,
        status: "online",

        // Live values
        temperature: round2(temperature),
        humidity: round2(humidity),

        // Last seen
        last_seen: lastSeen,

        // Daily
        daily_min_temp: round2Str(dailyMinTemp),
        daily_max_temp: round2Str(dailyMaxTemp),
        daily_avg_temp: round2Str(dailyAvgTemp),
        daily_min_temp_time: dailyMinTempTime,
        daily_max_temp_time: dailyMaxTempTime,

        daily_min_humidity: round2Str(dailyMinHum),
        daily_max_humidity: round2Str(dailyMaxHum),
        daily_avg_humidity: round2Str(dailyAvgHum),
        daily_min_humidity_time: dailyMinHumTime,
        daily_max_humidity_time: dailyMaxHumTime,

        // Monthly
        monthly_min_temp: round2Str(monthlyMinTemp),
        monthly_max_temp: round2Str(monthlyMaxTemp),
        monthly_avg_temp: round2Str(monthlyAvgTemp),
        monthly_min_temp_date: randomPastDate(),
        monthly_max_temp_date: randomPastDate(),

        monthly_min_humidity: round2Str(monthlyMinHum),
        monthly_max_humidity: round2Str(monthlyMaxHum),
        monthly_avg_humidity: round2Str(monthlyAvgHum),
        monthly_min_humidity_date: randomPastDate(),
        monthly_max_humidity_date: randomPastDate(),
    };
};
